// Scripts carregados separadamente do pack com "defer: true"

import $ from 'domtastic';

window.$ = $;

// Plugins do DOMtastic
require('../javascripts/auto/utils/domtastic/index');
require('../javascripts/auto/utils/domtastic/next');
